import { array, number, object, string } from 'yup';
import { BeneficiaryDTO } from '../../../../api/useEstatePlanningExplanationQuery';

export const beneficiaryValidation = object().shape({
  Name: string()
    .typeError('Required')
    .required('Required'),
  Percentage: number()
    .typeError('Required')
    .required('Required')
    .min(0, 'Must be greater than 0')
    .max(100, 'Must be less than 100'),
});

export const validation = object().shape({
  PrimaryBeneficiaries: array().of(beneficiaryValidation),
  ContingentBeneficiaries: array().of(beneficiaryValidation),
});

interface Beneficiary extends Omit<BeneficiaryDTO, 'Id'> {
  Id: string | null;
}

export interface Beneficiaries {
  PrimaryBeneficiaries: Beneficiary[];
  ContingentBeneficiaries: Beneficiary[];
  LastBeneficiaryUpdate: string | null;
}

export interface BaseFormValues extends Omit<Beneficiaries, 'LastBeneficiaryUpdate'> {
  LastUpdated: string | null;
}
